import React from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Webform,
} from '@uncinc/react-drupal-core';

import './style.scss';

const NewsletterSubscribeBlock = ({ entity }) => {

  const id = entity.getIn(['field_webform', 0, 'target_id']);
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'value'], '');

  return (
    <Container id="NewsletterSubscribe" className="NewsletterSubscribe">
      <div className="row">
        <div className="col-12 col-md-6 col-lg-5 offset-lg-1">
          <h2 className="NewsletterSubscribe__title">{title}</h2>
          {body && <WysiwygField
            property="schema:text"
            className="NewsletterSubscribe__body"
            html={body}
          />}
        </div>
        <div className="col-12 col-md-6 col-lg-5">
          <div className="NewsletterSubscribe__webformWrapper">
            {id && (
              <Webform
                scrollToTopAfterSubmit={false}
                scrollToTopAfterMultiFormStep={false}
                id={id}
              />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NewsletterSubscribeBlock;
